import { Inject } from '@angular/core';
import { Component } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { AcumaticaLoadingOptions } from './AcumaticaLoadingOptions';

@Component({
  template: `
    <div style="text-align: center;">
      <mat-spinner diameter="20" style="display:inline-block;"></mat-spinner> {{message}}
    </div>
`
})
export class AcumaticaLoadingSnackbarComponent {
  message: string | null;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) private data: AcumaticaLoadingOptions
  ) {
    this.message = data?.message || null;
  }
}
